import { AppService } from "@App";
import { IConfigService } from "@Config";
import {HttpClient, HttpResponse} from '@angular/common/http';
import { BaseService } from "@Services/base.service";
import { ReportDownloadService } from "@Services/reportdownload.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CaseSearch } from "@Models";

@Injectable()
export class CaseSearchService extends BaseService {

    publicApiBaseUrl: string;

    constructor(public appService: AppService, public configService: IConfigService, public httpClient: HttpClient, public reportDownloadService: ReportDownloadService) {
        super(appService, configService, httpClient);
        this.publicApiBaseUrl = this.configService.getConfiguration().publicApiUrl;
    }

    public getSearchTypes(accountId: string): Observable<string[]> {

        const clientId = this.appService.getClientId('');
        const url = `${this.publicApiBaseUrl}client/${clientId}/account/${accountId}/casesearch/searchtypes`;

        return super.getData<any>(url, clientId);

    }

    public getOutputsByAccountAndSearchType(accountId: string, searchType: string) : Observable<CaseSearch[]> {

        const clientId = this.appService.getClientId('');
        const url = `${this.publicApiBaseUrl}client/${clientId}/account/${accountId}/casesearch/outputs/${searchType}`;

        return super.getData<any>(url, clientId);
    }

    public deleteCaseSearchProperty(accountId: string, id: string): Observable<boolean> {

        const clientId = this.appService.getClientId('');
        const url = `${this.publicApiBaseUrl}client/${clientId}/account/${accountId}/casesearch/${id}`;

        return super.deleteData<boolean>(url, clientId);
    }

    public saveCaseSearch(accountId: string, searchType: string, searchMappings: CaseSearch[]) : Observable<boolean> {        
        const clientId = this.appService.getClientId('');
        const url = `${this.publicApiBaseUrl}client/${clientId}/account/${accountId}/casesearch/outputs/${searchType}`;

        return super.postData<boolean>(url, searchMappings, clientId);
    }
}